import { Button } from "@/components/ui/Button";
import { ScreenShell } from "../components/ScreenShell";

interface WelcomeScreenProps {
  readonly onStart: () => void;
}

export function WelcomeScreen({ onStart }: WelcomeScreenProps) {
  return (
    <ScreenShell
      center
      footer={
        <>
          <Button
            data-testid="onboarding-submit"
            variant="primary"
            size="lg"
            className="w-full"
            onClick={onStart}
          >
            Get Started
          </Button>
          <p className="text-center text-xs text-text-muted">
            Built for real meals, not just generic food databases.
          </p>
        </>
      }
    >
      <div className="flex min-h-0 flex-1 flex-col items-center gap-5 text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-accent">
          Welcome to BiteTrack
        </p>
        <div className="flex min-h-0 flex-1 items-center justify-center">
          <img
            src="/onboarding/hero.png"
            alt="Fresh meals photographed from above"
            className="max-h-full max-w-full rounded-3xl border border-border object-contain shadow-sm"
          />
        </div>
        <h1 className="text-2xl font-bold leading-tight text-text">
          Lose weight with AI that actually understands what you eat
        </h1>
        <p className="text-sm leading-relaxed text-text-muted">
          Snap meals, log calories, track progress, and get a personalised plan in minutes.
        </p>
      </div>
    </ScreenShell>
  );
}
